import { useMemo } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { CommonProperties } from "../common/common.interfaces";
import HamburgerSvg from '../common/components/svg/HamburgerSvg';
import UniversalConstructorImport from './components/UCImport';
import './styles/universal-constructor.css';

interface UniversalConstructorProps extends CommonProperties {} 
export default function UniversalConstructor (props : UniversalConstructorProps){

  const view = useMemo(() => {
    return <div>
      <div id='top'></div>
      <div className='beacon-card'>
        <table className='beacon-table'>
          <tbody>
            <tr>
              <td><span className='beacon-header'>Universal Constructor</span></td>
            </tr>
            <tr>
              <td><span className='beacon-label'>Import orders from any source, any marketplace.</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <Tabs>
        <TabList>
          <Tab key='importTab'>
            <span className='beacon-header'><HamburgerSvg height={25}/> IMPORT ORDERS</span>
          </Tab>
          <Tab key='configTab'>
            <span className='beacon-header'><HamburgerSvg height={25}/> CONFIGURE MAPPING</span>
          </Tab>

        </TabList>
        <TabPanel key='importTabPanel'>
          <UniversalConstructorImport />
        </TabPanel>
        <TabPanel key='configTabPanel'>
          config
        </TabPanel>
      </Tabs>
    </div>
  }, [])

  return view
}
